export default [
  {
    path: '',
    name: 'admin:customers',
    component: () => import(/* webpackChunkName: "clients" */ '@/views/admin/marketing/clients/ClientsTable.vue'),
  },
  {
    path: 'items-insight',
    name: 'admin:customers:items-insight',
    component: () => import(/* webpackChunkName: "clients" */ '@/views/admin/marketing/clients/ItemsInsight.vue'),
  },
  {
    path: 'statistics',
    name: 'admin:customers:statistics',
    component: () => import(/* webpackChunkName: "clients" */ '@/views/admin/marketing/clients/CustomerStatistics.vue'),
  },
  {
    path: 'profile/:id',
    name: 'admin:customers:profile',
    component: () => import(/* webpackChunkName: "clients" */ '@/views/admin/marketing/clients/CustomerDetails.vue'),
  },
  {
    path: 'edit/:id?',
    alias: 'add',
    name: 'admin:customers:form',
    component: () => import(/* webpackChunkName: "surveys" */ '@/views/admin/marketing/clients/components/forms/CustomerForm.vue'),
  },
  {
    path: 'reviews',
    name: 'admin:customers:reviews',
    component: () => import(/* webpackChunkName: "clients" */ '@/views/admin/marketing/clients/CustomerReviewsWizard.vue'),
  },
]
